import { render, staticRenderFns } from "./modalCertificado.vue?vue&type=template&id=54bd0619"
import script from "./modalCertificado.vue?vue&type=script&lang=js"
export * from "./modalCertificado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports